import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import ThemeRoot from '@components/main/ThemeRoot'
import App from '@routing/App'
import './index.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeRoot>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeRoot>
  </StrictMode>,
)
